import { Col, Row } from "../../ApiS/Grid-system/Grid-system";

interface GraduateTableProps {}

const GraduateTable: React.FC<GraduateTableProps> = () => {
  return (
    <>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> التسلسل </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">التسلسل</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الرقم الامتحاني </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الرقم الامتحاني</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الاسم والكنية </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الاسم والكنية</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> اسم الاب </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">اسم الاب</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> اسم الام </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">اسم الام</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> مكان الميلاد </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">مكان الميلاد</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> عام الميلاد </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">عام الميلاد</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> محل ورقم القيد </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">محل ورقم القيد</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الرقم الوطني </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الرقم الوطني</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> المحافظة </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">المحافظة</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> شعبة التجنيد </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">شعبة التجنيد</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الجنس </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الجنس</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الجنسية </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الجنسية</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الثانوية </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">الثانوية</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> عام التسجيل </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">عام التسجيل</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> المعدل </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">المعدل</div>
        </Col>
      </Row>
      <Row className=" border-b-2 border-b-Secondary  ">
        <Col
          lg={2}
          md={3}
          sm={3}
          className="bg-[#f8f0f6]   p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> التقدير </div>
        </Col>
        <Col lg={9} md={8} sm={8} className="flex items-center !mb-0">
          <div className="mx-5">التقدير</div>
        </Col>
      </Row>
    </>
  );
};

export default GraduateTable;
